import React, { useRef, useState, useEffect } from "react";

import "./styles.css";

import NewReleasesIcon from "@mui/icons-material/NewReleases";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";

import * as Material from "@mui/material";

import { useChallenge } from "../../contexts/ChallengeContext";

export default function ChallengePaymentBanner({ className }) {
  const { handleOpenSubscriptionModal, getSubscriptionStatus } = useChallenge();

  const subscriptionStatus = getSubscriptionStatus();

  if (subscriptionStatus?.status === "ADIMPLENT") return null;

  if (subscriptionStatus.status === "INADIMPLENT") {
    return (
      <div className={"px-2 py-2 cpb  " + className}>
        <NewReleasesIcon />
        <div className="cpb-text-info">
          <h4>Atenção, a assinatura desta comunidade não está ativa!</h4>
          <span>
            Para compartilhar sua comunidade com o público, ative sua assinatura
            agora
          </span>
        </div>
        <Material.Button
          onClick={handleOpenSubscriptionModal}
          variant="contained"
          className="cpb-cta"
          endIcon={<ToggleOnIcon />}
        >
          Ativar assinatura
        </Material.Button>
      </div>
    );
  }

  if (subscriptionStatus.status === "TRIAL") {
    const trialProgress = Math.round(
      ((subscriptionStatus.trial_days_past + 1) / 30) * 100
    );
    return (
      <div className={"px-2 py-2 cpb trial " + className}>
        <NewReleasesIcon />
        <div className="cpb-text-info">
          <h4>Você está utilizando o período de testes</h4>
          <Material.Box
            sx={{ display: "flex", alignItems: "center" }}
            className="pb-1"
          >
            <Material.Box sx={{ width: "100%", mr: 1 }}>
              <Material.LinearProgress
                variant="determinate"
                value={trialProgress}
              />
            </Material.Box>
            <Material.Box>
              <span
                variant="body2"
                style={{ color: "text.secondary", textWrap: "nowrap" }}
              >{`${
                30 - subscriptionStatus.trial_days_past
              } dias restantes`}</span>
            </Material.Box>
          </Material.Box>

          <span>
            Ative sua assinatura agora para garantir um desconto de R$480,00,
            enquanto esta oferta está disponível
          </span>
        </div>
        <Material.Button
          onClick={handleOpenSubscriptionModal}
          variant="contained"
          color="primary"
          className="cpb-cta"
          endIcon={<ToggleOnIcon />}
        >
          Ativar assinatura
        </Material.Button>
      </div>
    );
  }

  return null;
}
